import { render, staticRenderFns } from "./inner-rank-list.vue?vue&type=template&id=319769cc&scoped=true"
import script from "./inner-rank-list.vue?vue&type=script&lang=ts"
export * from "./inner-rank-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319769cc",
  null
  
)

export default component.exports